<template>
	<el-dialog :visible.sync="showWechatDialog" width="360px" id="mainDialog">
		<div style="text-align: center;">
			<img :src="wechatUrl" style="width: 197px;height: 197px;" />
			<div style="font-size: 18px;color: #333333;margin-top: -13px;">关注微信公众号，绑定微信</div>
			<div style="font-size: 14px;color: #999999;margin-top: 41px;">关注微信公众号，绑定微信后:</div>
			<div style="font-size: 14px;color: #999999;margin-top: 12px;">1、可在移动端中查看业务消息，处理业务事项。</div>
			<div
				style="font-size: 14px;color: #999999;text-align: center;"
			>2、登录时可以使用微信扫码登录。</div>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button type="confire_btn" @click="showWechatDialog = false" size="small">我知道了</el-button>
		</span>
	</el-dialog>
</template>

<script>
import { mapActions } from 'vuex';
export default {
	name: 'wxBindingComponent',

	data () {
		return {
			userid: '',
			wechatUrl: '',
			showWechatDialog: false,
		}
	},

	methods: {
		...mapActions([
      'reqBindWx',
    ]),
		getbmcwx(type,userid,openid) {
			let data = {
        userid: userid,
        usertype: type,
        domainname: window.location.host.substring(0, window.location.host.indexOf("."))
      }
			if (openid) {
				data.openid = openid
			}
			this.reqBindWx(data).then(res => {
				if(res.status === '10000') {
					this.wechatUrl = `https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=${res.data}`;
					this.showWechatDialog = true;
				}
			})

		},
	},

	mounted() {

	},
}
</script>


<style lang='scss'>

</style>
